import storage from 'redux-persist/lib/storage';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

import { setLanguage } from './checkingSlice';

// import buttonEsImg from '../../assets/es.svg';
// import buttonEnImg from '../../assets/en.svg';
import EsImg from '../../assets/new-icons/Spain-min.png';
import EnImg from '../../assets/new-icons/USA-min.png';
import purgeReducers from '../../utils/purgeReducers';
import usePageNavigation from '../../hooks/usePageNavigation';

function LanguagesPage() {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { navigateNextPage } = usePageNavigation();

  useEffect(() => {
    const checkStoreItems = async () => {
      await purgeReducers([
        'guests',
        'booking',
        'checking',
        'ocr',
      ]);

      const data = await localStorage.getItem('persist:checking');

      if (data === null) {
        window.location.reload();
        return;
      }

      console.log(data);
    };

    checkStoreItems();
  }, []);

  const handleSelectLanguage = (language) => {
    i18n.changeLanguage(language.toLowerCase());
    dispatch(setLanguage(language));
    // navigate('/Hotels');
    navigateNextPage('Hotels');
  };

  return (
    <div className="languages__content text-center">
      <p className="mb-0 app-fs-h1 app-lh-h1 app-fw-notosans-regular app-txt-granite">
        Welcome / Bienvenido
      </p>

      <p className="mb-0 app-txt-gray mt-3">
        Select a language / Seleccione un idioma
      </p>

      <Row className="mt-4">
        <Col xs={12} md={6} lg={6} className="text-md-start text-center mb-3">
          <Button
            variant=""
            className="border-0 app-bg-sand py-3"
            onClick={() => handleSelectLanguage('EN')}
          >
            <img src={EnImg} alt="Button en img" style={{ width: '50px', height: '33px' }} />
            <span className="ps-1 app-txt-granite-80-dark app-fw-notosans-bold align-middle">ENGLISH</span>
          </Button>
        </Col>
        <Col xs={12} md={6} lg={6} className="text-md-end text-center">
          <Button
            variant=""
            className="border-0 app-bg-sand py-3"
            onClick={() => handleSelectLanguage('ES')}
          >
            <img src={EsImg} alt="Button es img" style={{ width: '50px', height: '33px' }} />
            <span className="ps-1 app-txt-granite-80-dark app-fw-notosans-bold align-middle">ESPAÑOL</span>
          </Button>
        </Col>
      </Row>
    </div>
  );
}

export default LanguagesPage;
